<template>
  <transition name="slide">
    <div v-if="showModal" class="modal-notificacoes">
      <div class="conteudo">
        <div class="header">
          <div>
            <img src="@/assets/imgs/icone_vivinho.svg" />
            <h1>Últimos Informes Comerciais</h1>
          </div>
          <button @click.prevent="showNotificacoes(false)">
            <img src="@/assets/imgs/icone_fechar.svg" />
          </button>
        </div>

        <template>
          <div v-if="carregando.header" class="carregando">
            <img src="@/assets/imgs/spinner_amarelo.svg" alt />
          </div>


            <div v-else-if="dataHeader.length <= 0 && dataHeaderFalandoDeGente.length <= 0 " class="blankslate">
            <img src="@/assets/imgs/search-not-found - Branco.svg" alt />
            <h2>Nenhum informe comercial encontrado.</h2>
          </div>

          <template v-else>
            <div class="ultimas-notificacoes row">
              <!-- <div class="isLoading" v-if="carregando.noticia">
                <categoria-loading />
                <mobile-loading />
              </div>-->
              <ul class="materias col">
                <li
                  v-for="materia in dataHeaderColunaEsquerda"
                  v-bind:key="materia.id"
                  :class="materia.lido !== '' ? 'lido' : ''"
                >
                  <router-link
                    :to="{ path: `/categoria/${materia.categoria.slug}/post/${materia.slug}` }"
                    @click.native="showNotificacoes(false)"
                  >
                    <article class="materia">
                      <div class="capa-materia">
                        <span class="categoria">{{ materia.categoria.descricao }}</span>
                        <img
                          v-if="materia.xs"
                          :src="materia.xs"
                          :alt="materia.titulo"
                          class="imagem-destaque"
                        />
                        <img
                          v-else
                          src="@/assets/imgs/no-image-portal.jpg"
                          :alt="materia.titulo"
                          class="imagem-destaque"
                        />
                      </div>
                      <div class="texto-materia">
                        <h2>{{ materia.titulo }}</h2>
                        <span>
                          <strong>Postado em:</strong>
                          {{ materia.data_publicacao }}
                        </span>
                      </div>
                    </article>
                  </router-link>
                </li>
              </ul>

              <ul class="materias col">
                <li
                  v-for="materia in dataHeaderColunaDireita"
                  v-bind:key="materia.id"
                  :class="materia.lido !== '' ? 'lido' : ''"
                >
                  <router-link
                    :to="{ path: `/categoria/${materia.categoria.slug}/post/${materia.slug}` }"
                    @click.native="showNotificacoes(false)"
                  >
                    <article class="materia">
                      <div class="capa-materia">
                        <span class="categoria">{{ materia.categoria.descricao }}</span>
                        <img
                          v-if="materia.xs"
                          :src="materia.xs"
                          :alt="materia.titulo"
                          class="imagem-destaque"
                        />
                        <img
                          v-else
                          src="@/assets/imgs/no-image-portal.jpg"
                          :alt="materia.titulo"
                          class="imagem-destaque"
                        />
                      </div>
                      <div class="texto-materia">
                        <h2>{{ materia.titulo }}</h2>
                        <span>
                          <strong>Postado em:</strong>
                          {{ materia.data_publicacao }}
                        </span>
                      </div>
                    </article>
                  </router-link>
                </li>
              </ul>
            </div>

            <router-link
              v-if="!carregando.header && headerMais"
              to="/notificacao"
              class="botao"
              @click.native="showNotificacoes(false)"
              >Ver mais</router-link
            >
          </template>
        </template>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
// import { SpringSpinner } from 'epic-spinners';

export default {
  name: 'Notificacao',
  data() {
    return {
      blank: true,
    };
  },
  components: {
    // SpringSpinner,
  },
  props: {
    ativo: {
      default: false,
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters({
      carregando: 'notificacoes/carregando',
      showModal: 'notificacoes/showModal',
      dataHeader: 'notificacoes/dataHeader',
      headerMais: 'notificacoes/headerMais',
      dataHeaderFalandoDeGente: 'notificacoes/dataHeaderFalandoDeGente',
      headerFalandoDeGenteMais: 'notificacoes/headerFalandoDeGenteMais',
    }),
    dataHeaderColunaEsquerda(){
      if(this.dataHeader.length > 0) return this.dataHeader.slice(0,3);
      return this.dataHeaderFalandoDeGente.slice(0,3);
    },
    dataHeaderColunaDireita(){
      if(this.dataHeader.length > 0) {
        if(this.dataHeaderFalandoDeGente.length > 0) return this.dataHeaderFalandoDeGente.slice(0,3);
        return this.dataHeader.slice(3,6)
      }
      return this.dataHeaderFalandoDeGente.slice(3,6);
    },
    dataHeaderIC(){
      if(this.dataHeaderFalandoDeGente.length > 0) return this.dataHeader.slice(0,3);
      return this.dataHeader;
    },
    dataHeaderFDG(){
      if(this.dataHeader.length > 0) return this.dataHeaderFalandoDeGente.slice(0,3);
      return this.dataHeaderFalandoDeGente;
    }
  },
  methods: {
    ...mapActions({
      showNotificacoes: 'notificacoes/showNotificacoes',
      getNotificacaoHeader: 'notificacoes/getNotificacaoHeader',
      getNotificacaoFalandoDeGenteHeader: 'notificacoes/getNotificacaoFalandoDeGenteHeader',
    }),
  },
  beforeMount() {
    // Notificacao Header
    this.getNotificacaoHeader();
    this.getNotificacaoFalandoDeGenteHeader();
  },
  mounted() {
    document.body.addEventListener('keyup', e => {
      if (e.keyCode === 27) {
        this.showNotificacoes(false);
      }
    });
  },
};
</script>

<style lang="scss" scoped>
@import '@/estilo/sass/_formulas.scss';
@import '@/estilo/sass/_cores.scss';

$largura-foto-grande: 185px;
$altura-foto-grande: 125px;

.modal-notificacoes {
  @extend %gradiente_twilight;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
  width: 100%;
  height: 100%;

  & .conteudo {
    @extend %flex;
    @extend %area-de-utilizacao;
    @extend %direction-column;
    @extend %justify-center;
    @extend %align-items-center;
    margin: 0 auto;
    padding: 0px 40px;
    width: 100%;
    height: 100%;

    & .header {
      @extend %flex;
      @extend %direction-row;
      @extend %justify-between;
      @extend %align-items-center;
      width: 100%;

      & div {
        @extend %flex;
        @extend %direction-row;
        @extend %align-items-center;

        & img {
          @extend %nao-selecionavel;
          width: 4vmax;
          min-width: 40px;
          margin-right: 20px;
          margin-right: 2vmax;
        }

        & h1 {
          @extend %nao-selecionavel;
          font-family: 'VivoType';
          font-weight: bold;
          font-size: 30px;
          line-height: 30px;
          font-size: 2vmax;
          line-height: 2vmax;
          letter-spacing: 0.05vmax;
          color: white;
          max-width: 100%;
        }
      }

      & button {
        outline: none;
        cursor: pointer;
        background: transparent;
        border: 0px;
        margin-right: -20px;
      }
    }

    & .ultimas-notificacoes {
      margin: 3% 0;

      & .materias {
        @extend %flex;
        @extend %direction-column;
        @extend %justify-between;
        @extend %flex-wrap;
        width: 450px;
        height: 100%;
        box-sizing: border-box;
        padding: 0px;
        margin: 0px;
        position:relative;
        float: left;

        & li {
          width: 45%;

          & a {
            margin: 0px;
            padding: 0px;
            text-decoration: none;
            cursor: pointer;

            & article {
              @extend %flex;
              @extend %direction-row;
              @extend %justify-between;
              @extend %align-items-center;
              width: 100%;
              margin-bottom: 3%;

              & .capa-materia {
                min-width: $largura-foto-grande;
                max-width: $largura-foto-grande;
                height: $altura-foto-grande;
                border-radius: 5px;
                position: relative;

                &:hover {
                  transition: 0.3s ease;
                  @extend %gradiente_twilight;
                }

                &:hover {
                  transform: scale(1.03);

                  & > .categoria {
                    background: transparent;
                    font-size: 13px;
                    // color: transparent;
                    // border: 1px solid white;
                  }
                }

                & .categoria {
                  position: absolute;
                  font-size: 10px;
                  top: 3px;
                  left: 3px;
                  color: white;
                  padding: 0px 3px;
                  border-radius: 3px;
                  font-weight: 600;
                  // @extend %gradiente_rosa;
                  background: $cor_rosa;
                  opacity: 1 !important;
                  z-index: 100;
                  transition: all 0.2s ease-in-out;
                }

                & img:hover {
                  transition: 0.3s ease;
                  opacity: 0.3;
                }

                & .imagem-destaque {
                  transition: 0.5s ease;
                  object-fit: cover;
                  width: 100%;
                  height: $altura-foto-grande;
                  border-radius: 5px;
                }
              }

              & .texto-materia {
                margin-left: 20px;
                min-width: 65%;
                max-width: 65%;

                & h2 {
                  font-family: 'VivoType';
                  font-weight: bolder;
                  color: white;
                  font-size: 23px;
                  line-height: 27px;
                  // letter-spacing: 0.01vmax;
                  margin: 5px 0px;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  display: -webkit-box;
                  -webkit-line-clamp: 3;
                  -webkit-box-orient: vertical;
                }

                & span {
                  font-style: italic;
                  font-size: 10px;
                  font-weight: 500;
                  color: $cor_amarelo;
                }
              }
            }
          }
        }
        & .lido {
          filter: grayscale(1);
          opacity: 0.5;
        }
      }
    }

    & .carregando {
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 50vh;

      & img {
        width: 10vw;
        width: 10vmax;
      }
    }

    & .blankslate {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      min-height: 50vh;
      opacity: 0.5;

      & h2 {
        text-align: center;
        color: white;
      }

      & img {
        width: 10vw;
        width: 10vmax;
      }
    }

    & .botao {
      @extend %flex;
      @extend %align-items-center;
      @extend %justify-center;
      @extend %direction-row;
      @extend %nao-selecionavel;
      cursor: pointer;
      border-radius: 10px;
      text-decoration: none;
      font-family: 'VivoType';
      font-weight: bold;
      text-transform: uppercase;
      font-size: 20px;
      letter-spacing: 0px;
      color: white;
      background: transparent;
      border: 1px solid white;
      width: 100%;
      padding: 15px 0px;
      outline: none;

      &:hover {
        color: white;
        background: $cor_primaria;
        -webkit-box-shadow: 0px 10px 30px 1px rgba(102, 0, 153, 0.35);
        -moz-box-shadow: 0px 10px 30px 1px rgba(102, 0, 153, 0.35);
        box-shadow: 0px 10px 30px 1px rgba(102, 0, 153, 0.35);
      }
      &:disabled {
        color: white;
        background: $cor_primaria;
        -webkit-box-shadow: 0px 10px 30px 1px rgba(102, 0, 153, 0.35);
        -moz-box-shadow: 0px 10px 30px 1px rgba(102, 0, 153, 0.35);
        box-shadow: 0px 10px 30px 1px rgba(102, 0, 153, 0.35);
      }
    }
  }
}

.spring-spinner {
  box-sizing: border-box;
  * {
    box-sizing: border-box;
  }
  height: 60px;
  width: 60px;
  .spring-spinner-part {
    overflow: hidden;
    height: calc(60px / 2);
    width: 60px;
    &.bottom {
      transform: rotate(180deg) scale(-1, 1);
    }
  }
  .spring-spinner-rotator {
    width: 60px;
    height: 60px;
    border: calc(60px / 7) solid transparent;
    border-right-color: $cor_secundaria;
    border-top-color: $cor_secundaria;
    border-radius: 50%;
    box-sizing: border-box;
    animation: spring-spinner-animation 3s ease-in-out infinite;
    transform: rotate(-200deg);
  }
}

@keyframes spring-spinner-animation {
  0% {
    border-width: calc(60px / 7);
  }

  25% {
    border-width: calc(60px / 23.33);
  }

  50% {
    transform: rotate(115deg);
    border-width: calc(60px / 7);
  }

  75% {
    border-width: calc(60px / 23.33);
  }

  100% {
    border-width: calc(60px / 7);
  }
}

::-webkit-scrollbar {
  width: 4px !important;
}

::-webkit-scrollbar-track {
  background: transparent !important;
}

::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3) !important;
  border: 0px !important;
  border-radius: 3px !important;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 1) !important;
}

@media all and (min-width: 300px) and (max-width: 1024px) {
  .modal-notificacoes {
    & .conteudo {
      height: 90vh;
      align-items: center;
      justify-content: flex-start;
      padding: 5vh 30px;
      width: calc(100% - 60px);
      overflow-y: scroll;

      & .header {
        & div {
          max-width: 100%;

          & img {
            width: 4vh;
            min-width: 40px;
          }

          & h1 {
            font-size: calc((((100vw + 100vh) * 2) / 150) + 5px);
            line-height: calc((((100vw + 100vh) * 2) / 150) + 5px);
          }
        }

        & button {
          & img {
            max-width: 40px;
          }
        }
      }

      & .ultimas-notificacoes {
        margin: 4% 0;

        & .materias {
          width: 100%;

          & li {
            width: 100%;

            & a {
              & article {
                margin-bottom: 2%;

                & .capa-materia {
                  min-width: 120px;
                  max-width: 120px;
                  height: 90px;

                  & .imagem-destaque {
                    height: 100%;
                  }
                }

                & .texto-materia {
                  margin-left: 3%;
                  min-width: 55%;
                  max-width: 55%;

                  & h2 {
                    font-size: 15px;
                    line-height: 18px;
                    margin: 1% 0px;
                  }

                  & span {
                    font-size: 8px;
                  }
                }
              }
            }
          }
        }
      }

      & .carregando {
        min-height: 60vh;

        & img {
          width: 15vh;
          width: 15vmax;
        }
      }

      & .blankslate {
        min-height: 60vh;

        & h2 {
          font-size: 16px;
          color: white;
        }

        & img {
          width: 15vw;
          width: 15vmax;
        }
      }

      & .botao {
        font-size: 14px;
        padding: 10px 0px;
      }
    }
  }
}

@media all and (min-width: 680px) and (max-width: 1024px) {
  .modal-notificacoes {
    & .conteudo {
      height: 100vh;
      align-items: center;
      justify-content: center;
      padding: 0px;
      margin: 0 auto;
      overflow: hidden;
      // width: 100%;
      // overflow-y: scroll;

      & .header {
        & div {
          max-width: 80%;

          & img {
            width: 4vh;
            min-width: 40px;
          }

          & h1 {
            font-size: calc((((100vw + 100vh) * 2) / 150) + 5px);
            line-height: calc((((100vw + 100vh) * 2) / 150) + 5px);
          }
        }

        & button {
          margin-right: 0px;

          & img {
            max-width: 40px;
          }
        }
      }

      & .ultimas-notificacoes {
        margin: 5% 0;

        & .materias {
          width: calc(100vw - 60px);

          & li {
            width: 48%;

            & a {
              & article {
                margin-bottom: 6%;

                & .capa-materia {
                  min-width: 160px;
                  max-width: 160px;
                  height: 130px;

                  & .imagem-destaque {
                    height: 100%;
                  }
                }

                & .texto-materia {
                  margin-left: 3%;
                  min-width: 50%;
                  max-width: 50%;

                  & h2 {
                    font-size: 17px;
                    line-height: 20px;
                    margin: 1% 0px;
                  }

                  & span {
                    font-size: 9px;
                  }
                }
              }
            }
          }
        }
      }

      & .botao {
        font-size: 14px;
        padding: 10px 0px;
      }
    }
  }
}

@media all and (min-width: 300px) and (max-width: 679px) and (orientation: landscape) {
  .modal-notificacoes {
    & .conteudo {
      height: 100vh;
      align-items: center;
      justify-content: center;
      padding: 0px;
      margin: 0 auto;
      overflow: hidden;
      // width: 100%;
      // overflow-y: scroll;

      & .header {
        & div {
          max-width: 80%;

          & img {
            width: 4vh;
            min-width: 40px;
          }

          & h1 {
            font-size: calc((((100vw + 100vh) * 2) / 150) + 5px);
            line-height: calc((((100vw + 100vh) * 2) / 150) + 5px);
          }
        }

        & button {
          margin-right: 0px;

          & img {
            max-width: 40px;
          }
        }
      }

      & .ultimas-notificacoes {
        margin: 5% 0;

        & .materias {
          width: calc(100vw - 60px);

          & li {
            width: 48%;

            & a {
              & article {
                margin-bottom: 6%;

                & .capa-materia {
                  min-width: 110px;
                  max-width: 110px;
                  height: 80px;

                  & .imagem-destaque {
                    height: 100%;
                  }
                }

                & .texto-materia {
                  margin-left: 3%;
                  min-width: 50%;
                  max-width: 50%;

                  & h2 {
                    font-size: 17px;
                    line-height: 20px;
                    margin: 1% 0px;
                  }

                  & span {
                    font-size: 9px;
                  }
                }
              }
            }
          }
        }
      }

      & .botao {
        font-size: 14px;
        padding: 10px 0px;
      }
    }
  }
}

/**
  Transition
 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 2.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.slide-enter-active {
  -webkit-animation: slide-in-top 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  animation: slide-in-top 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}
.slide-leave-active {
  -webkit-animation: slide-out-top 0.3s cubic-bezier(0.55, 0.085, 0.68, 0.53) both;
  animation: slide-out-top 0.3s cubic-bezier(0.55, 0.085, 0.68, 0.53) both;
}
.slide-enter,
.slide-leave-to {
  transform: translateX(10px);
  opacity: 0;
}

@-webkit-keyframes slide-in-top {
  0% {
    -webkit-transform: translateY(-1000px);
    transform: translateY(-1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    opacity: 1;
  }
}
@keyframes slide-in-top {
  0% {
    -webkit-transform: translateY(-1000px);
    transform: translateY(-1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    opacity: 1;
  }
}

@-webkit-keyframes slide-out-top {
  0% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    opacity: 1;
  }
  100% {
    -webkit-transform: translateY(-1000px);
    transform: translateY(-1000px);
    opacity: 0;
  }
}
@keyframes slide-out-top {
  0% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    opacity: 1;
  }
  100% {
    -webkit-transform: translateY(-1000px);
    transform: translateY(-1000px);
    opacity: 0;
  }
}
</style>
